import { EMPTY_OBJECT } from "client/Misc/utils";
import {
	ReadonlyRefObject,
	useEffect,
	useState
} from "react";

export const useIntersection = (
	ref: ReadonlyRefObject<HTMLElement | null>,
	options: IntersectionObserverInit = EMPTY_OBJECT
): IntersectionObserverEntry | null => {
	const [intersectionObserverEntry, setIntersectionObserverEntry] =
		useState<IntersectionObserverEntry | null>(null);

	useEffect(
		() => {
			const { current } = ref;

			if (!current) {
				return;
			}

			const handler = (entries: IntersectionObserverEntry[]): void => {
				setIntersectionObserverEntry(entries[0]);
			};

			const observer = new IntersectionObserver(handler, options);
			observer.observe(current);

			return () => {
				setIntersectionObserverEntry(null);
				observer.disconnect();
			};
		},
		[options, ref]
	);

	return intersectionObserverEntry;
};
